import { TableColumnDefinition } from '@antimatterhq/ui/types/TableColumnDefinition';

export const fieldSpecColumnDefinitions: TableColumnDefinition[] = [
  {
    id: 'name',
    title: 'Name',
    width: 250,
  },
  {
    id: 'action',
    title: '',
    tooltip: false,
    width: 32,
    enableFiltering: false,
    enableSorting: false,
    enableResize: false,
  },
  {
    id: 'type',
    title: 'Type',
    width: 80,
  },
  {
    id: 'definition',
    title: 'Definition',
    width: 200,
  },
  {
    id: 'edit',
    title: '',
    tooltip: false,
    width: 32,
    enableFiltering: false,
    enableSorting: false,
    enableResize: false,
    pinned: 'right',
  },
];
